import PluginSlot from './components/PluginSlot.vue';
import registry from './registry.js';
import { providePluginContext } from './composables/usePluginContext.js';

export default {
  install(app) {
    app.component('PluginSlot', PluginSlot);
    app.provide('airjump-registry', registry);
    const store = app.config.globalProperties.$store;
    if (store) {
      providePluginContext(app, store);
    }

    // Initialize Pinia store on next tick (after pinia is ready)
    import('./store/useAirjumpStore.js').then(({ useAirjumpStore }) => {
      const airjumpStore = useAirjumpStore();
      airjumpStore.loadGlobals();
    });

    // Hide native CW resolve button (replaced by ConversationStatusPill)
    const style = document.createElement('style');
    style.textContent = '.resolve-actions { display: none !important; }';
    document.head.appendChild(style);
  },
};
